import {
  TransferPayment,
  TransferPaymentInput
} from '../../lib/types/models/transfer/transfer-payments'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTransferPayment(input: TransferPaymentInput & { transferId: number }) {
  const { transferId, ...rest } = input

  return restApiClient
    .url(constructApiUrl(API.transfer.createPayment.url, { transferId }))
    .post<TransferPayment, TransferPaymentInput>(rest)
}
